export const kordisTeamQuestions = [
  "Is the main issue navigating between clients, or understanding each client's financial state quickly?",
  'Do CFOs need a portfolio-level overview first, or a direct entry into a specific client workspace?',
  'Are we optimizing for analysis, reporting, or monitoring multiple companies at once?',
];

export const kordisTeamAnswer = 'You switch organizations, and that pretty much sets your context.';

export const kordisFrictions = [
  {
    title: 'Black-box outputs',
    body: "\u201CSome of these tools don't even show the underlying data or formulas, just \u2018here's what you should do.\u2019\u201D",
  },
  {
    title: 'Data fragmentation',
    body: 'Up to 90% of P&L impact can get lost in actuals calculations before any forecasting begins.',
  },
  {
    title: 'Slow planning systems',
    body: 'Some ERPs take days to process actuals, making AI forecasting impractical without a simpler parallel model.',
  },
  {
    title: 'Overhyped tools',
    body: 'Promised automation that needed so much manual data prep the time savings disappeared.',
  },
];

export const kordisInsight = {
  quote: 'CFOs are not anti-AI, they are pro-trust.',
  source: 'Fractional CFO Insights 2025',
};

export const kordisHybridModel =
  'AI handles routine bookkeeping, reconciliation and report drafting. The fractional CFO focuses on strategy, scenario interpretation and client advice.';

export const kordisCoreFeatures = [
  'Rolling cash flow forecast engine',
  'Anomaly detection + narrative surface',
  'Scenario planning canvas',
  'Proactive insight alerts',
  'Board-ready narrative generator',
];

export const kordisPipeline = ['QuickBooks API', 'MCP layer', 'LLM', 'Kronos+ UI'];
